<template>
  <div class="p-vod-setting">
    <div class="p-vod-setting__operate">
      <plv-button @click="distributeVodResource('add')">添加资源</plv-button>
      <plv-button @click="distributeVodResource('recycle')">回收资源</plv-button>
    </div>
    <div class="p-vod-setting-form">
      <div class="p-vod-setting-form__title">
        资源分配
      </div>
      <plv-column>
        <plv-column-item prefix="空间">{{ vodData.space }} GB</plv-column-item>
        <plv-column-item prefix="流量">{{ vodData.flow }} GB</plv-column-item>
      </plv-column>
    </div>

    <vodDistribute ref="distributeDialog" :visible.sync="distributeDialogVisible" @updateSuccess="updateSuccess" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import vodDistribute from './components/vodDistribute.vue';
import accountInfoMixin from '@/mixins/accountInfo';
export default {
  components: {
    vodDistribute
  },
  mixins: [accountInfoMixin],
  data() {
    return {
      distributeDialogVisible: false,
      vodData: {
        remainFlow: '',
        remainSpace: '',
      },
      unionId: ''
    };
  },
  computed: {
    ...mapGetters({
      subAccountInfo: 'account/subAccountInfo'
    }),
  },
  watch: {
    subAccountInfo: {
      handler(value) {
        this.vodData.flow = value.remainFlow;
        this.vodData.space = value.remainSpace;
      },
      immediate: true
    }
  },
  created() {
    const { params: { id } } = this.$route;
    if (id) this.unionId = id;
  },
  methods: {
    distributeVodResource(type = 'add') {
      this.$refs.distributeDialog.open(type, {
        ...this.vodData,
        unionId: this.unionId
      });
    },
    async updateSuccess(form) {
      this.$toast.success('保存成功');
      this.distributeDialogVisible = false;
      const subAccountInfo = { ...this.subAccountInfo };
      subAccountInfo.remainFlow += form.flow;
      subAccountInfo.remainSpace += form.space;
      this.$store.commit('account/setSubAccountInfo', subAccountInfo);
    }
  }
};
</script>

<style lang="scss" scoped>
.p-vod-setting {
  padding: 0 18px;
  .p-vod-setting-form__title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .p-vod-setting-form-item__unit {
    margin-left: 8px;
  }
  .p-vod-setting__operate {
    margin: 20px 0;
    .plv-button {
      margin-right: 20px;
    }
  }
}
</style>
